<mat-card
    class="altair-card tickets-resolved-card mb-25 border-radius bg-white border-none d-block"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <h5 class="mt-0 mb-0">
                {{data.name}}&nbsp;
            </h5>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <h3 class="mb-0 lh-1">
            {{total}}
        </h3>
        <span class="info d-block position-relative text-success">
            {{average | number: '1.0-2'}} <span class="text-body">AVG</span>
        </span>
        <div class="chart">
            <apx-chart
                [series]="chartOptions.series!"
                [chart]="chartOptions.chart!"
                [xaxis]="chartOptions.xaxis!"
                [stroke]="chartOptions.stroke!"
                [dataLabels]="chartOptions.dataLabels!"
                [colors]="chartOptions.colors!"
                [yaxis]="chartOptions.yaxis!"
                [fill]="chartOptions.fill!"
                [grid]="chartOptions.grid!"
                [labels]="chartOptions.labels!"
                [legend]="chartOptions.legend!"
            ></apx-chart>
        </div>
    </mat-card-content>
</mat-card>
